module.exports = __webpack_public_path__ + "static/media/font_regular.bb03ffea.woff2";